export function LandingFooter({ content, logoUrl, appName }) {
  return (
    <footer className="relative z-20 py-12 px-4 sm:px-6 lg:px-8 bg-[#007a33]">
      {/* Grass silhouette border */}
      <div
        className="absolute left-0 right-0 w-full"
        style={{
          height: '22px', bottom: '100%', marginBottom: '-1px',
          backgroundColor: '#007a33',
          WebkitMaskImage: 'url(/grass-border.png)', WebkitMaskSize: 'auto 100%', WebkitMaskRepeat: 'repeat-x', WebkitMaskPosition: 'center bottom',
          maskImage: 'url(/grass-border.png)', maskSize: 'auto 100%', maskRepeat: 'repeat-x', maskPosition: 'center bottom',
        }}
      />
      <div className="max-w-7xl mx-auto">
        {/* Desktop: horizontal row */}
        <div className="hidden md:flex items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src={logoUrl} alt={appName} className="object-contain" style={{ width: '3.5rem', height: '3.5rem' }} />
            <div>
              <span className="text-white" style={{ fontSize: '1.2rem', fontWeight: 900 }}>{appName}</span>
              <p className="text-white/90" style={{ fontSize: '0.9rem', lineHeight: '1.0rem' }}>{content.footer?.description}</p>
            </div>
          </div>
          <div className="flex items-center gap-6">
            <a href="/about" className="text-white/70 hover:text-white transition-colors" style={{ fontSize: '0.8rem' }}>
              About
            </a>
            <a href="/privacy-policy" className="text-white/70 hover:text-white transition-colors" style={{ fontSize: '0.8rem' }}>
              Privacy Policy
            </a>
            <a href="/terms" className="text-white/70 hover:text-white transition-colors" style={{ fontSize: '0.8rem' }}>
              Terms
            </a>
            {content.footer?.links?.filter(link => !['Privacy Policy', 'About', 'Contact', 'Terms', 'Terms of Service'].includes(link.label)).map((link, index) => (
              <a key={index} href={link.url} className="text-white/70 hover:text-white transition-colors" style={{ fontSize: '0.8rem' }}>
                {link.label}
              </a>
            ))}
          </div>
        </div>

        {/* Mobile/Tablet: centered stacked layout */}
        <div className="md:hidden flex flex-col items-center text-center gap-4">
          <img src={logoUrl} alt={appName} className="object-contain" style={{ width: '4.5rem', height: '4.5rem' }} />
          <div>
            <span className="text-white block" style={{ fontSize: '1.2rem', fontWeight: 900 }}>{appName}</span>
            <p className="text-white/90 mt-1" style={{ fontSize: '0.9rem', lineHeight: '1.0rem' }}>{content.footer?.description}</p>
          </div>
          <div className="flex items-center justify-center gap-6 mt-2">
            <a href="/about" className="text-white/70 hover:text-white transition-colors" style={{ fontSize: '0.8rem' }}>
              About
            </a>
            <a href="/privacy-policy" className="text-white/70 hover:text-white transition-colors" style={{ fontSize: '0.8rem' }}>
              Privacy Policy
            </a>
            <a href="/terms" className="text-white/70 hover:text-white transition-colors" style={{ fontSize: '0.8rem' }}>
              Terms
            </a>
            {content.footer?.links?.filter(link => !['Privacy Policy', 'About', 'Contact', 'Terms', 'Terms of Service'].includes(link.label)).map((link, index) => (
              <a key={index} href={link.url} className="text-white/70 hover:text-white transition-colors" style={{ fontSize: '0.8rem' }}>
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white/20 text-center text-white/60" style={{ fontSize: '0.9rem' }}>
          &copy; {new Date().getFullYear()} {appName}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
